function errorCode(error,fallback='LIVE_RECOVERY_FAILED'){
  return String(error?.code||error?.message||fallback).slice(0,80);
}

export function createLiveSessionRecovery({
  sessions,
  notificationReconciler=null,
  diagnostics=null
}={}){
  if(!sessions?.active)throw new TypeError('sessions.active is required');

  async function reconcileNotifications(session){
    if(typeof notificationReconciler?.reconcileActiveSession!=='function'){
      return Object.freeze({status:'not_configured'});
    }
    try{
      const result=await notificationReconciler.reconcileActiveSession({session});
      return Object.freeze({
        status:'reconciled',
        result:result??null
      });
    }catch(error){
      try{diagnostics?.capture?.('journal.live-recovery.notifications',error);}catch{}
      return Object.freeze({
        status:'failed',
        errorCode:errorCode(error,'LIVE_NOTIFICATION_RECONCILE_FAILED')
      });
    }
  }

  async function recover(){
    const session=await sessions.active();
    if(!session){
      return Object.freeze({
        status:'none',
        session:null,
        notifications:Object.freeze({status:'not_applicable'})
      });
    }

    const notifications=await reconcileNotifications(session);
    return Object.freeze({
      status:'active',
      session,
      sessionId:session.id,
      notifications
    });
  }

  return Object.freeze({recover});
}
